import type { ComponentEvent } from '../../types/project';

export function getPageOnLoadActionId(events: ComponentEvent[] | undefined): string {
  return events?.find((event) => event.event === 'onLoad')?.actionId ?? '';
}

export function assignPageOnLoad(events: ComponentEvent[] | undefined, actionId: string): ComponentEvent[] {
  const current = events ?? [];
  const firstOnLoadIndex = current.findIndex((event) => event.event === 'onLoad');
  if (!actionId) return current.filter((event) => event.event !== 'onLoad');
  const nextEvent: ComponentEvent = { event: 'onLoad', actionId };
  if (firstOnLoadIndex < 0) return [...current, nextEvent];
  return current.flatMap((event, index) => {
    if (event.event !== 'onLoad') return [event];
    return index === firstOnLoadIndex ? [nextEvent] : [];
  });
}
